import { updatesData } from "@/mocks/homeData";

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <h2 className="text-xl md:text-3xl font-heading text-foreground-50 text-center mb-2">最新动态</h2>
        <p className="text-foreground-500 text-sm text-center mb-8 md:mb-10">平台内容更新与功能优化实时速递</p>
        <div className="relative pl-6 md:pl-8 border-l-2 border-background-300">
          {updatesData.map((item, i) => (
            <div key={i} className="relative pb-8 last:pb-0">
              <div className="absolute -left-[25px] md:-left-[29px] w-3 h-3 rounded-full bg-primary-500 ring-4 ring-background-100"></div>
              <div className="flex flex-wrap items-center gap-2 mb-1.5">
                <span className="px-2 py-0.5 bg-accent-500/20 text-accent-400 text-xs font-medium rounded-full whitespace-nowrap">
                  {item.tag}
                </span>
                <time className="text-foreground-600 text-xs" dateTime={item.date}>{item.date}</time>
              </div>
              <h3 className="text-foreground-100 text-sm md:text-base font-medium mb-1">{item.title}</h3>
              <p className="text-foreground-500 text-xs md:text-sm leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}